export function locumCanSeeShiftRates(shift, userRole = "locum") {
  if (userRole && userRole !== "locum") {
    return true;
  }
  if (!shift) {
    return true;
  }
  if (shift.hidePayRateForLocum === true) {
    return false;
  }
  if (shift.shiftBookedAsInternalStaff) {
    return false;
  }
  return true;
}

/**
 * Job-level recommended rates are one range for the whole job.
 * A locum may see that range only when every known shift allows rates.
 * Mixed visibility hides the summary so a hidden-rate shift cannot leak
 * through it; shift cards still show rates for the shifts that allow them.
 * An incomplete shift list is treated as unknown and the summary stays hidden.
 * When the list is complete but empty, this returns true so existing job-level
 * gates (internal staff / internal locum) still decide.
 */
export function locumCanSeeJobRates(shifts, userRole = "locum", options = {}) {
  if (userRole && userRole !== "locum") {
    return true;
  }

  const { shiftsComplete = true } = options;
  const list = Array.isArray(shifts) ? shifts.filter(Boolean) : [];

  if (list.some((shift) => !locumCanSeeShiftRates(shift, userRole))) {
    return false;
  }

  if (!shiftsComplete) {
    return false;
  }

  return true;
}

/**
 * Record whether the job-level recommended range is safe to show, using the
 * shift list as it stands now. Call this before any userId filter: calendar
 * navigation keeps only one locum's shifts, and that subset can hide a
 * restricted shift that the whole-job range still describes.
 */
export function stampHideRecommendedRateForLocum(job, userRole = "locum") {
  if (!job || typeof job !== "object") {
    return job;
  }
  const shifts = Array.isArray(job.shifts) ? job.shifts : [];
  job.hideRecommendedRateForLocum = !locumCanSeeJobRates(shifts, userRole);
  return job;
}
